export default "__VITE_ASSET__4cTUm3dn6r8NbXqfsWOe8w__"